export function getVisibleParentElement (el) {
  // only go up one level;
  if (el && el.parentNode) {
    let b = el.parentNode.getBoundingClientRect();
    if ((b.bottom - b.top) > 0 && (b.right - b.left) > 0) {
      return el.parentNode;
    }
  }

  return el;
}

export function nearestElement (el) {
  // do not seleect body
  if (el === document.body) {
    return null;
  }

  // do not select element that has the same dimension as body
  // let a = document.body.getBoundingClientRect();
  // let b = el.getBoundingClientRect();
  // if (a.left === b.left && a.right === b.right) {
  //   console.log('el compare body', a, b)
  //   return null;
  // }

  // select the whole svg image
  if (el instanceof SVGElement) {
    while (el.parentNode instanceof SVGElement) {
      el = el.parentNode;
    }
  }

  return el;
}

/* ES5 syntax for now, maybe also needed for JSSDK */
export function elementHasOwnHandler (element) {
  var tests = [function (node) {
    return ['form', 'input', 'select', 'textarea', 'submit', 'a'].indexOf(node.tagName.toLowerCase()) > -1;
  },
  function (node) {
    // for onclick properties and attributes
    return node.onclick || node.getAttribute('onclick');
  },
  function (node) {
    return !!(window.jQuery._data || window.jQuery.data)(node, 'events');
  },
  function (node) {
    // jquery 1.3.x and 1.4x
    return node.getAttribute('data-events');
  },
  function (node) {
    // jquery 1.5.x
    for (var i = 0; i < window.Event.observers.length; i++) {
      var observer = window.Event.observers[i];
      if ((observer || [])[0] === node) {
        return true;
      }
    }
    return false;
  },
  function (node) {
    // jquery 1.6 to 1.6.0.3
    return window.Event.cache[node._eventId || node._prototypeEventID[0]].click[0];
  }];

  for (var i = 0; i < tests.length; i++) {
    var test = tests[i];
    try {
      if (test(element)) {
        return true;
      }
    } catch (e) {}
  }
  return false;
};

export function nearestInteractiveElement (element, cache) {
  if (cache && cache[element] && cache[element].element === element) {
    return cache[element].closest;
  }
  var tagName = element.tagName.toLowerCase();
  if (tagName === 'html' || tagName === 'head') {
    return null;
  }

  // next, try to find the closest element that seems interactive
  var child = void 0;
  var closest = void 0;
  var candidate = element;
  var visited_candidates = [];

  do {
    visited_candidates.push(candidate);

    // skip candidates that don't accept pointer events
    if (candidate.style['pointer-events'] === 'none') {
      child = candidate;
      candidate = candidate.parentElement;
      continue;
    }

    // if the cursor becomes default, assume that the child was clickable
    if (child) {
      var candidateStyles = window.getComputedStyle(candidate);
      var childStyles = window.getComputedStyle(child);
      var cursor = candidateStyles.cursor;
      if ((cursor === 'default' || cursor === 'auto') && cursor !== childStyles.cursor) {
        closest = child;
        break;
      }
    }

    // if there are data- attributes we assume that it's used for something interactive
    var attrs = candidate.attributes;
    for (var i = 0; i < attrs.length; i++) {
      if (/^data\-/.test(attrs[i].name)) {
        closest = candidate;
        break;
      }
    }

    // if the element has its own click handler, it is almost certainly clickable
    if (elementHasOwnHandler(candidate)) {
      closest = candidate;
      break;
    }

    child = candidate;
    candidate = candidate.parentElement;
  } while (candidate && candidate.tagName.toLowerCase() !== 'body');

  if (cache && closest) {
    for (var _i = 0; _i < visited_candidates.length; _i++) {
      var _candidate = visited_candidates[_i];
      cache[_candidate] = closest;
    }
    cache[element] = {
      closest: closest,
      element: element
    };
  }

  return closest || element;
};

function _previousElementSibling (el) {
  let ELEMENT_NODE = 1;
  if (el.previousElementSibling) {
    return el.previousElementSibling;
  } else {
    do {
      el = el.previousSibling;
    } while (el && el.nodeType !== ELEMENT_NODE);
    return el;
  }
};

function _nextElementSibling (el) {
  let ELEMENT_NODE = 1;
  if (el.nextElementSibling) {
    return el.nextElementSibling;
  } else {
    do {
      el = el.nextSibling;
    } while (el && el.nodeType !== ELEMENT_NODE);
    return el;
  }
};
export function allElementSibling (elem) {
  let sibling = [];
  let currentElem = elem;
  while ((currentElem = _previousElementSibling(currentElem)) !== null) {
    if (currentElem.tagName === elem.tagName) {
      sibling.push(currentElem);
    }
  }

  currentElem = elem;
  while ((currentElem = _nextElementSibling(currentElem)) !== null) {
    if (currentElem.tagName === elem.tagName) {
      sibling.push(currentElem);
    }
  }
  // go for parent level
  if (sibling.length === 0) {
    let currentElem = elem.parentNode;
    while ((currentElem = _previousElementSibling(currentElem)) !== null) {
      if (currentElem.tagName === elem.parentNode.tagName) {
        sibling.push(currentElem);
      }
    }
    currentElem = elem.parentNode;
    while ((currentElem = _nextElementSibling(currentElem)) !== null) {
      if (currentElem.tagName === elem.parentNode.tagName) {
        sibling.push(currentElem);
      }
    }
  }
  // console.log('sibling', sibling);
  return sibling;
};

function _getClassName (elem) {
  if (elem.tagName.toLowerCase() === 'svg') {
    return elem.className.baseVal || elem.getAttribute('class') || '';
  } else {
    return elem.className || '';
  }
}

function _getId (elem) {
  return elem.id || '';
}

export function getSimilarElements (target) {
  let ELEMENT_NODE = 1;
  if (!target || target === document || target === document.body.parentNode || target.nodeType !== ELEMENT_NODE) {
    return false;
  }
  var targetElementList = [target];
  var curEl = target;
  while (curEl.parentNode && curEl !== document.body) {
    targetElementList.push(curEl.parentNode);
    curEl = curEl.parentNode;
  }

  let elementsJson = [];
  let selectorList = [];
  let length = targetElementList.length;
  for (let i = 0; i < length; i++) {
    let el = targetElementList[i];
    // crawl up to max of 5 nodes to populate text content
    if (i < 4) {
      let classes = _getClassName(el).trim();
      let id = _getId(el);
      let tagName = el.tagName.toLowerCase();
      // console.log('tagName', tagName);
      // console.log('classes', classes);
      if (classes === '') {
        classes = tagName;
      } else {
        if (classes.split(' ').length === 1) {
          classes = tagName.concat('.').concat(classes);
        } else {
          classes = classes.split(' ').reduce((pre, cur) => {
            return pre.concat('.').concat(cur);
          });
          classes = tagName.concat('.').concat(classes);
        }
      }

      let selector = id !== '' ? '#'+id : classes;
      elementsJson.push(el);
      if (i === 0) {
        selectorList.push(tagName);
      } else if (length > 2 && i ===1) {
        selectorList.push(classes);
      } else {
        selectorList.push(selector);
      }
    }
  }
  // console.log('elementsJson', elementsJson);
  // console.log('selectorList', selectorList);
  return selectorList.reverse().join('  ');
};



/** WEBPACK FOOTER **
 ** ./src/utils/dom.js
 **/